import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React from 'react';
import { clearParams } from 'framework/utils/clearParams';
import { DateFilterItem } from 'framework/filter/date/DateFilterItem';
import { FilterBar } from 'framework/filter/FilterBar';
import { MoneyRangeFilterComponent } from 'framework/filter/MoneyRangeFilterComponent';
import { isFiltered } from 'framework/utils/isFiltered';
import { ICustomerAccountLinesQueryParams } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';

interface IProps {
	params: ICustomerAccountLinesQueryParams;
	onFilter: (params: ICustomerAccountLinesQueryParams) => void;
	paddingLeft: number;
}

const exclusions: (keyof ICustomerAccountLinesQueryParams)[] = ['hasOutstandingBalance', 'hasSettlementProposal'];

export const Filter = ({ params, onFilter, paddingLeft }: IProps) => {
	const strings = useLocalization();

	return (
		<FilterBar
			isFiltered={isFiltered(params, exclusions)}
			onClear={() => onFilter(clearParams(params, exclusions))}
			paddingLeft={paddingLeft}>
			<DateFilterItem
				label={strings.salesDate}
				after={params.salesDateCreatedAfter}
				before={params.salesDateBefore}
				setSelected={(after, before) => onFilter({ ...params, salesDateCreatedAfter: after, salesDateBefore: before })}
			/>
			<MoneyRangeFilterComponent
				label={strings.saldoBetween}
				selected={{ min: params.outstandingBalanceMoreThan, max: params.outstandingBalanceLessThan }}
				setSelected={val => onFilter({ ...params, outstandingBalanceLessThan: val.max, outstandingBalanceMoreThan: val.min })}
				icon={<HelpOutlineIcon />}
			/>
		</FilterBar>
	);
};
